// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

export async function currentUser(options?: { [key: string]: any }) {
  return request('/api/user/me', {
    method: 'GET',
    ...(options || {}),
  });
}

export async function outLogin(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/user/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

export async function login(
  body: API.LoginParams,
  options?: { [key: string]: any },
) {
  return request('/api/user/login', {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

export async function getUserList(options?: { [key: string]: any }) {
  return request('/api/user/all', {
    method: 'GET',
  });
}
export async function getUserPage(options?: { [key: string]: any }) {
  return request('/api/user/page', {
    method: 'GET',
    params: {
      ...options,
    },
  });
}

export interface UserImportResult {
  total: number;
  successCount: number;
  errorCount: number;
  errors: string[];
}

export function importUsers(file: File) {
  const data = new FormData();
  data.append('file', file);
  return request<{ code: number; msg: string; data: UserImportResult }>(
    '/api/user/import',
    {
      method: 'POST',
      data,
    },
  );
}

export async function downloadUserImportTemplate() {
  const file = await request<Blob>('/api/user/import-template', {
    method: 'GET',
    responseType: 'blob',
    skipErrorHandler: true,
    showError: false,
  });
  if (file.type.includes('json')) {
    const error = JSON.parse(await file.text());
    throw new Error(error.msg || '下载失败，请确认登录状态及老师权限');
  }
  if (
    !file.size ||
    !file.type.includes(
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    )
  ) {
    throw new Error('模板下载失败，服务器未返回 Excel 文件');
  }
  return file;
}

export async function addUser(options?: { [key: string]: any }) {
  return request('/api/user/create', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}
export async function updateUser(options?: { [key: string]: any }) {
  return request('/api/user/update', {
    method: 'POST',
    data: options,
  });
}
export async function delUser(options?: { [key: string]: any }) {
  return request('/api/user/del', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    pageSize?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

export async function getQiniuToken(options?: { [key: string]: any }) {
  return request<{
    code: number;
    msg: string;
    data: { token: string; keyPrefix: string };
  }>('/api/qiniu/upload-token', {
    method: 'GET',
    ...(options || {}),
  });
}
